"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineTableField = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const table_field_1 = require("../table-field/table-field");
const inline_table_field_toolbar_1 = require("./inline-table-field-toolbar");
const inline_table_field_row_1 = require("./inline-table-field-row");
const inline_table_context_1 = require("./inline-table-context");
const form_context_1 = require("../../composite/form/form-context");
exports.InlineTableField = react_1.forwardRef(function InlineTableField({ ToolbarComponent = inline_table_field_toolbar_1.InlineTableFieldToolbar, RowComponent = inline_table_field_row_1.InlineTableFieldRow, showRadioCond = lodash_1.stubFalse, showDetailBtnCond = lodash_1.stubFalse, withRemove = true, initNewItem = emptyObject, ...props }, ref) {
    const context = react_1.useMemo(() => ({ withRemove, initNewItem }), [withRemove, initNewItem]);
    const { editing } = react_1.useContext(form_context_1.FormContext);
    /**
     * Hide actions if disabled, and both dndOrdering / removeButton not visible
     */
    const visibleActionsColumn = !props.disabled || props.useDnDOrdering || (withRemove && editing);
    return (react_1.default.createElement(inline_table_context_1.InlineTableFieldContext.Provider, { value: context },
        react_1.default.createElement(table_field_1.TableField, Object.assign({ ToolbarComponent: ToolbarComponent, RowComponent: RowComponent, showRadioCond: showRadioCond, showDetailBtnCond: showDetailBtnCond, visibleActionsColumn: visibleActionsColumn }, props, { ref: ref }))));
});
function emptyObject() {
    return {};
}
//# sourceMappingURL=inline-table-field.js.map